import React from "react";
import { Card, Typography } from "@material-ui/core";
import { IBillingResult } from "nodeDetails/types";
import { useDomainNumberFormatter } from "common/useNumberFormatter";
import {
  calculateTotal,
  getDisplayBillingPeriod,
} from "nodeDetails/functions/billingResultFunctions";
import OverviewItem from "./OverviewItem";
import styles from "./Overview.module.scss";
import { useTranslation } from "react-i18next";

interface Props {
  billingResult: IBillingResult;
}

const Overview = ({ billingResult }: Props) => {
  const { t } = useTranslation();
  const { formatCurrency } = useDomainNumberFormatter();

  const totalPrice = calculateTotal(billingResult);

  return (
    <Card className={styles.container}>
      <Typography variant="h2" gutterBottom>
        {t("Invoice data")}
      </Typography>
      <OverviewItem
        label={t("Period")}
        value={getDisplayBillingPeriod(billingResult.Start, billingResult.End)}
      />
      <OverviewItem
        label={t("Object number")}
        value={billingResult.ObjectNumber}
      />
      <OverviewItem
        label={t("Total")}
        value={formatCurrency(
          totalPrice.total + totalPrice.vat + totalPrice.rounding
        )}
      />
    </Card>
  );
};

export default Overview;
